import { gql } from "@/services/httpAdapter";

export const onCreateOEMChevroletCsi = gql`
	subscription onCreateOEMChevroletCsi($commissionCycleId: String) {
		onCreateOEMChevroletCsi(commissionCycleId: $commissionCycleId) {
			_id
			commissionCycleId
			employeeMetrics {
				_id
				user {
					_id
					fullName
				}

				metrics {
					metricName
					metricValue
				}
			}
			referenceMetrics {
				_id
				referenceName
				referenceType
				metrics {
					metricName
					metricValue
				}
			}
			lastModifiedOn
		}
	}
`;

export const onCreateOEMMitsubishiCsi = gql`
	subscription onCreateOEMMitsubishiCsi($commissionCycleId: String) {
		onCreateOEMMitsubishiCsi(commissionCycleId: $commissionCycleId) {
			_id
			commissionCycleId
			employeeMetrics {
				_id
				user {
					_id
					fullName
				}
				metrics {
					metricName
					metricValue
				}
			}
			referenceMetrics {
				_id
				referenceName
				referenceType
				metrics {
					metricName
					metricValue
				}
			}
			lastModifiedOn
		}
	}
`;

export const onCreateOEMVolvoCsi = gql`
	subscription onCreateOEMVolvoCsi($commissionCycleId: String) {
		onCreateOEMVolvoCsi(commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId
			employeeMetrics {
				_id
				user {
					_id
					fullName
				}
				metrics {
					metricName
					metricValue
				}
			}
			referenceMetrics {
				_id
				referenceName
				referenceType
				metrics {
					metricName
					metricValue
				}
			}
			lastModifiedOn
		}
	}
`;
